<!--<button #btn type="button" pButton icon="pi pi-align-right" class="sildemenu-btn" (click)="menu.toggle($event)"></button>
<p-slideMenu #menu [model]="sildemenu" [popup]="true" backLabel="MENU" [viewportHeight]="650"></p-slideMenu>-->
<header>
  <div id="m-menu" class="m-menu mmenuMobile">
    <div id="my-header" class="navbar-fixed-top">
      <a href="#my-menu"></a>
      <div class="haburger" id="menuClick">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <nav id="my-menu">
        <ul>
          <li class="mobileNavPanel">
            <button href="javascript:void(0)" id="mmClose" class="mmenuClose"><b class="icon-cancel"></b></button>
            <!-- <a class="languages">EN</a> -->
            <app-language-selector inNavbar="true" menuClass="dropdown-menu dropdown-menu-right">
            </app-language-selector>
            <div class="mobileNavPanel_items">
              <a href="explore-seychelles"><i class="icon-map"></i></a>
              <a *ngIf="currentUser" class="wishlist" title="Wishlist" href="/wishlist"
                ><i class="icon icon-wishlist"></i
              ></a>
              <a
                *ngIf="currentUser"
                translate
                id="signOut"
                data-toggle="modal"
                (click)="logout()"
                data-target="#SignOut"
                >Logout</a
              >
              <a
                (click)="showLoginDialog()"
                translate
                *ngIf="!currentUser"
                id="signIn"
                data-toggle="modal"
                data-target="#SignIn"
                >Login</a
              >
            </div>
          </li>

          <li class="username" *ngIf="currentUser">
            <span
              ><b>{{ userLetter }}</b
              >{{ username }}</span
            >
            <ul>
              <li>
                <a translate (click)="showProfileDialog()">{{ 'Profile' | translate }}</a>
              </li>
              <li>
                <a translate (click)="showChangePasswordDialog()">{{ 'Change Password' | translate }}</a>
              </li>
            </ul>
          </li>
          <li class="search-menu">
            <p translate>Search -Explore Seychelles</p>
            <div class="input-group">
              <!-- <input class="form-control" placeholder="Explore the Seychelles" name="srch-term" #serach id="srch-term" type="text"> -->
              <p-autoComplete
                [(ngModel)]="suggestionsText"
                placeholder="Enter search keyword"
                [suggestions]="newserachResults"
                (completeMethod)="search($event)"
                minLength="3"
                autocomplete="on"
                immutable="false"
                (onSelect)="goToProductDetails($event)"
                class="p-autocomplete"
              ></p-autoComplete>
              <div class="input-group-btn">
                <button class="btn btn-default" type="submit" (click)="searchByValue(suggestionsText)">
                  <b class="icon-search-light"></b>
                </button>
              </div>
            </div>

            <p class="nearBy">
              <!-- <b class="icon-direction"></b> -->
            </p>
            <i *ngFor="let keyword of popularKeywords" (click)="searchByPage(keyword)" class="tiles">
              {{ keyword.name }}
            </i>
          </li>

          <li *ngFor="let menu of sildemenu[1].planyourvisit">
            <span>{{ menu.title | translate }}</span>
            <ul>
              <li *ngFor="let menu of sildemenu[1].planyourvisit[0].items">
                <!-- <a href="javascript:void(0)" (click)="categories(menu)">{{ menu.title | translate }}</a> -->
                <a href="{{ menu.url }}">{{ menu.title | translate }}</a>
              </li>
              <!-- <li *ngFor="let menu of sildemenu[1].planyourvisit[0].gettingaround">
                <span>{{ menu.title | translate }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[1].planyourvisit[0].gettingaround[0].items">
                    <a (click)="categories(menu)">{{ menu.title | translate }}</a>
                  </li>
                </ul>
              </li>
              <li *ngFor="let menu of sildemenu[1].planyourvisit[0].aboutUs">
                <span>{{ menu.title | translate }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[1].planyourvisit[0].aboutUs[0].items">
                    <a href="javascript:void(0)" (click)="aboutUs(menu.title)">{{ menu.title | translate }}</a>
                  </li>
                </ul>
              </li>
              <li *ngFor="let menu of sildemenu[1].planyourvisit[0].travelInfo">
                <span>{{ menu.title | translate }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[1].planyourvisit[0].travelInfo[0].items">
                    <a href="javascript:void(0)" (click)="travelInfo(menu)">{{ menu.title | translate }}</a>
                  </li>
                </ul>
              </li> -->
            </ul>
          </li>
          <li *ngFor="let menu of sildemenu[2].experience">
            <span>{{ menu.title | translate }}</span>
            <ul>
              <!-- <li *ngFor="let menu of sildemenu[2].experience[0].activities">
                <span>{{ menu.title }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[2].experience[0].activities[0].items">
                    <a href="javascript:void(0)" (click)="categories(menu)">{{ menu.title }}</a>
                  </li>
                </ul>
              </li> -->
              <!-- <li *ngFor="let menu of sildemenu[2].experience[0].activities">
                <a href="javascript:void(0)" (click)="categories(menu)">{{ menu.title | translate }}</a>
              </li>
              <li *ngFor="let menu of sildemenu[2].experience[0].attractions">
                <span>{{ menu.title | translate }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[2].experience[0].attractions[0].items">
                    <a href="javascript:void(0)" (click)="categories(menu)">{{ menu.title | translate }}</a>
                  </li>
                </ul>
              </li>
              <li *ngFor="let menu of sildemenu[2].experience[0].specialinterest">
                <span>{{ menu.title | translate }}</span>
                <ul>
                  <li *ngFor="let menu of sildemenu[2].experience[0].specialinterest[0].items">
                    <a href="javascript:void(0)" (click)="specialCategories(menu)">{{ menu.title | translate }}</a>
                  </li>
                </ul>
              </li> -->
              <li *ngFor="let menu of sildemenu[2].experience[0].items1">
                <!-- <a href="javascript:void(0)" (click)="categories(menu)">{{ menu.title | translate }}</a> -->
                <a href="{{ menu.url }}">{{ menu.title | translate }}</a>
              </li>
              <li *ngFor="let menu of sildemenu[2].experience[0].items2">
                <!-- <a href="javascript:void(0)" (click)="specialCategories(menu)">{{ menu.title | translate }}</a> -->
                <a href="{{ menu.url }}">{{ menu.title | translate }}</a>
              </li>
            </ul>
          </li>
          <li *ngFor="let menu of sildemenu[0].islands">
            <a href="{{ menu.url }}">{{ menu.title | translate }}</a>
            <!-- <a (click)="categories(menu)">{{ menu.title | translate }}</a> -->
            <!-- <ul>
              <li *ngFor="let menu of sildemenu[0].islands[0].items">
       
               <a (click)="islands(menu.selectedIsland)">{{ menu.title | translate }}</a>
              </li>
            </ul> -->
          </li>
          <li *ngFor="let menu of sildemenu[4].explore">
            <a href="{{ menu.url }}">{{ menu.title | translate }}</a>
            <!-- <ul class="row">
              <li class="hide-before">
                <div class="row px-2 mb-2">
                  <div class="col-md-6 text-right">
                    <a href="{{ menu.overview.url }}" class="see-overview" style="padding-right: 0px">
                      <span
                        style="padding: 0px; margin-right: 0px; display: inline"
                        class="pi pi-search see-overview-icon"
                      ></span>
                      {{ menu.overview.title | translate }}
                    </a>
                  </div>
                </div>
              </li>
              <li class="col-md-6 p-1" (click)="categories(menu)" *ngFor="let menu of sildemenu[4].explore[0].items">
                <div class="island-dropdown-item" [ngStyle]="{ 'background-image': 'url(' + menu.image + ')' }">
                  <div class="island-icon-bg"></div>
                  <img src="/assets/images/icon-park_sphere.png" class="island-icon" />
                  <div class="island-title-pos">
                    <span class="island-title">{{ menu.title | translate }} </span>
                  </div>
                </div>
              </li>
            </ul> -->
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <nav class="navbar navbar-expand-md navbar-light">
    <div class="container-fluid">
      <div class="branding-logo" *ngFor="let menu of headermenu[0].headerlog">
        <a class="navbar-brand" href="/home"
          ><img id="logoid" src="/assets/images/seychelleslogore.png" alt="The Seychelles Islands"
        /></a>
      </div>
      <button
        class="navbar-toggler noMobile"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse noMobile" id="navbarCollapse">
        <ul class="navbar-nav mr-auto ml-auto">
          <li class="dropdown dropdown-large" *ngFor="let menu of headermenu[0].headeritems[0].item2">
            <a href="{{ menu.url }}" class="nav-link dropdown-toggle" data-toggle="dropdown"
              >{{ menu.title | translate }}
              <!-- <i class="icon-down-open-big"></i> -->
            </a>
            <!-- <a href="{{menu.url}}" class="dropdown-toggle" data-toggle="dropdown">{{menu.title}} </a> -->
            <ul class="dropdown-menu dropdown-menu-large row" [ngClass]="language">
              <li class="planYourVisitBg" style="background-image: url('../../../assets/images/bannnerImagecut.jpg')">
                <div class="col-md-12">
                  <ul>
                    <li>
                      <div class="row">
                        <!-- <div class="col-md-4" *ngFor="let menu of headermenu[0].headeritems[0].item2[0].items"> -->
                        <div class="col-md-5 col-lg-4" [class.col-lg-5]="language === 'IT' || language === 'FR'">
                          <!-- <a href="javascript:void(0)" (click)="categories(menu)"> -->
                          <div class="menuTitles">
                            <!-- <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                              <div class="islandTitle">{{ menu.title | translate }}</div> -->
                            <ul>
                              <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].row1">
                                <!-- <i class="fa fa-home" (click)="categories(menu)"></i> -->
                                <img
                                  class="menuIcons"
                                  loading="lazy"
                                  src="{{ menu.image }}"
                                  (click)="categories(menu)"
                                />
                                <!-- <b (click)="categories(menu)">{{ menu.title | translate }}</b> -->
                                <a
                                  href="{{ menu.url }}"
                                  style="font-size: 16px; color: #707070 !important; font-weight: bolder"
                                  >{{ menu.title | translate }}</a
                                >
                              </li>
                            </ul>
                          </div>
                          <!-- </a> -->
                        </div>
                        <div class="col-md-5 col-lg-4" [class.col-lg-5]="language === 'IT' || language === 'FR'">
                          <div class="menuTitles">
                            <!-- <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                              <div class="islandTitle">{{ menu.title | translate }}</div> -->
                            <ul>
                              <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].row2">
                                <!-- <i class="fa fa-home" (click)="categories(menu)"></i> -->
                                <img
                                  class="menuIcons"
                                  loading="lazy"
                                  src="{{ menu.image }}"
                                  (click)="categories(menu)"
                                />
                                <!-- <b (click)="categories(menu)">{{ menu.title | translate }}</b> -->
                                <a
                                  href="{{ menu.url }}"
                                  style="font-size: 16px; color: #707070 !important; font-weight: bolder"
                                  >{{ menu.title | translate }}</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- <div class="col-md-2">
                  <ul>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].gettingaround[0].option2">
                      <a href="javascript:void(0)" (click)="categories(menu)">
                        <div class="islandImage">
                          <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                          <div class="islandTitle">{{ menu.title | translate }}</div>
                        </div>
                      </a>
                    </li>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].gettingaround[0].links">
                      <a href="javascript:void(0)" (click)="categories(menu)"
                        ><span>{{ menu.title | translate }}</span></a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-md-2">
                  <ul>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].about[0].option1">
                      <a href="javascript:void(0)" (click)="aboutUs(menu.title)">
                        <div class="islandImage">
                          <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                          <div class="islandTitle">{{ menu.title | translate }}</div>
                        </div>
                      </a>
                    </li>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].about[0].links">
                      <a href="javascript:void(0)" (click)="aboutUs(menu.title)"
                        ><span>{{ menu.title | translate }}</span></a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-md-2">
                  <ul>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].travelInfo[0].option1">
                      <a href="javascript:void(0)" (click)="travelInfo(menu)">
                        <div class="islandImage">
                          <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                          <div class="islandTitle">{{ menu.title | translate }}</div>
                        </div>
                      </a>
                    </li>
                    <li *ngFor="let menu of headermenu[0].headeritems[0].item2[0].travelInfo[0].links">
                      <a href="javascript:void(0)" (click)="travelInfo(menu)"
                        ><span>{{ menu.title | translate }}</span></a
                      >
                    </li>
                  </ul>
                </div> -->
              </li>
            </ul>
          </li>
          <!-- //plan your visit-->
          <li class="nav-item dropdown dropdown-large" *ngFor="let menu of headermenu[0].headeritems[0].item3">
            <!-- expirence-->
            <a href="{{ menu.url }}" class="nav-link dropdown-toggle" data-toggle="dropdown"
              >{{ menu.title | translate }}
              <!-- <i class="icon-down-open-big"></i> -->
            </a>
            <ul class="dropdown-menu dropdown-menu-large row secondmenu" [ngClass]="language">
              <li class="" style="margin: 0px 15px">
                <div class="row">
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-6" style="padding: 0px">
                        <!-- <p class="dropdown-header" *ngFor="let menu of headermenu[0].headeritems[0].item3[0].Activites">
                                                {{ menu.subtitle }}
                                            </p> -->
                        <ul>
                          <li>
                            <!-- <a href="javascript:void(0)" (click)="activities(menu)"> -->
                            <div class="menuTitles">
                              <!-- <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                          <div class="islandTitle">{{ menu.title | translate }}</div> -->
                              <ul>
                                <li *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row1">
                                  <!-- <i class="fa fa-home" (click)="categories(menu)"></i> -->
                                  <img
                                    class="menuIcons"
                                    src="{{ menu.image }}"
                                    (click)="categories(menu)"
                                    style="width: 48px; height: 48px"
                                    loading="lazy"
                                  />
                                  <!-- <b (click)="categories(menu)"> {{ menu.title | translate }}</b> -->
                                  <a
                                    href="{{ menu.url }}"
                                    style="font-size: 16px; color: #707070 !important; font-weight: bolder"
                                    >{{ menu.title | translate }}</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- </a> -->
                          </li>
                          <!-- <li *ngFor="let menu of headermenu[0].headeritems[0].item3[0].Activites[0].links">
                      <a href="javascript:void(0)" (click)="activities(menu)"
                        ><span>{{ menu.title | translate }}</span></a
                      >
                    </li> -->
                        </ul>
                      </div>
                      <div class="col-md-6">
                        <!-- <p class="dropdown-header" *ngFor="let menu of headermenu[0].headeritems[0].item3[0].Atrractions">
                    {{ menu.subtitle }}
                  </p> -->
                        <ul>
                          <li>
                            <!-- <a href="javascript:void(0)" (click)="categories(menu)"> -->
                            <div class="menuTitles">
                              <!-- <img class="img-responsive" src="../../../assets/images/{{ menu.image }}" />
                          <div class="islandTitle">{{ menu.title | translate }}</div> -->
                              <ul>
                                <li *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row2">
                                  <!-- <i class="fa fa-home" (click)="categories(menu)"></i> -->
                                  <img
                                    class="menuIcons"
                                    loading="lazy"
                                    src="{{ menu.image }}"
                                    (click)="categories(menu)"
                                  />
                                  <!-- <b (click)="categories(menu)">{{ menu.title | translate }}</b> -->
                                  <a
                                    href="{{ menu.url }}"
                                    style="font-size: 16px; color: #707070 !important; font-weight: bolder"
                                    >{{ menu.title | translate }}</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- </a> -->
                          </li>
                          <!-- <li *ngFor="let menu of headermenu[0].headeritems[0].item3[0].Atrractions[0].links">
                      <a href="javascript:void(0)" (click)="categories(menu)"
                        ><span>{{ menu.title | translate }}</span></a
                      >
                    </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-4 nopadding" *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row3">
                        <p>
                          <img
                            style="width: 100%; height: 100px"
                            class="round"
                            (click)="specialCategories(menu)"
                            src="../../../assets/images/{{ menu.image }}"
                            loading="lazy"
                          />
                          <!-- <b class="centered" (click)="specialCategories(menu)">{{
                            menu.title | translate
                          }}</b> -->
                          <a
                            href="{{ menu.url }}"
                            class="centered"
                            style="text-decoration: none; font-size: 14px; color: #fff !important; font-weight: bolder"
                            >{{ menu.title | translate }}</a
                          >
                        </p>
                      </div>
                    </div>
                    <!-- start second menu  -->
                    <div class="row equal" style="margin-top: -14px">
                      <div class="col-md-4 nopadding" *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row4">
                        <img
                          style="width: 100%; height: 205px"
                          class="round"
                          (click)="specialCategories(menu)"
                          src="../../../assets/images/{{ menu.image }}"
                          loading="lazy"
                        />
                        <p class="centered">
                          <!-- <b (click)="specialCategories(menu)">{{
                            menu.title | translate
                          }}</b> -->
                          <a
                            href="{{ menu.url }}"
                            class="centered"
                            style="text-decoration: none; font-size: 14px; color: #fff !important; font-weight: bolder"
                            >{{ menu.title | translate }}</a
                          >
                        </p>
                      </div>

                      <div class="col-md-8">
                        <div class="row">
                          <div
                            class="col-md-6 nopadding"
                            *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row5"
                          >
                            <img
                              style="width: 100%; height: 100px"
                              class="round"
                              (click)="specialCategories(menu)"
                              src="../../../assets/images/{{ menu.image }}"
                              loading="lazy"
                            />
                            <p class="centered">
                              <!-- <b (click)="specialCategories(menu)">{{
                                menu.title | translate
                              }}</b> -->
                              <a
                                href="{{ menu.url }}"
                                class="centered"
                                style="
                                  text-decoration: none;
                                  font-size: 14px;
                                  color: #fff !important;
                                  font-weight: bolder;
                                "
                                >{{ menu.title | translate }}</a
                              >
                            </p>
                          </div>
                        </div>

                        <div class="row">
                          <div
                            class="col-md-12 nopadding"
                            *ngFor="let menu of headermenu[0].headeritems[0].item3[0].row6"
                          >
                            <img
                              style="width: 100%; height: 100px"
                              class="round"
                              (click)="specialCategories(menu)"
                              src="../../../assets/images/{{ menu.image }}"
                              loading="lazy"
                            />
                            <p class="centered" *ngIf="menu.title !== 'Sustainable Seychelles'">
                              <!-- <b (click)="specialCategories(menu)">{{
                                menu.title | translate
                              }}</b> -->
                              <a
                                href="{{ menu.url }}"
                                class="centered"
                                style="
                                  text-decoration: none;
                                  font-size: 14px;
                                  color: #fff !important;
                                  font-weight: bolder;
                                "
                                >{{ menu.title | translate }}</a
                              >
                            </p>
                            <p class="centered" style="width: 180px" *ngIf="menu.title == 'Sustainable Seychelles'">
                              <!-- <b (click)="specialCategories(menu)">{{
                                menu.title | translate
                              }}</b> -->
                              <a
                                href="{{ menu.url }}"
                                class="centered"
                                style="
                                  text-decoration: none;
                                  width: 180px;
                                  font-size: 14px;
                                  color: #fff !important;
                                  font-weight: bolder;
                                "
                                >{{ menu.title | translate }}</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </li>
          <!-- //expirence-->
          <li class="nav-item dropdown dropdown-large" *ngFor="let menu of headermenu[0].headeritems[0].item">
            <!-- island -->
            <a href="{{ menu.url }}" (click)="categories(menu)" class="nav-link dropdown-toggle" data-toggle="dropdown"
              >{{ menu.title | translate }}
              <!-- <i class="icon-down-open-big"></i> -->
            </a>
            <!-- <ul class="dropdown-menu dropdown-menu-large row">
              <li class="container">
                <div class="col-md-4">
                  <ul>
                    <li class="dropdown-header" *ngFor="let menu of headermenu[0].headeritems[0].item[0].inner">
                      {{ menu.subtitle | translate }}
                    </li>
                    <li>
                      <div class="row">
                        <div class="col-md-6" *ngFor="let menu of headermenu[0].headeritems[0].item[0].inner[0].data">
                          <a href="javascript:void(0)" (click)="islandsDetails(menu.view_node)">
                            <div class="islandImage">
                              <img
                                class="img-responsive"
                                src="../../../assets/images/{{ menu.image }}"
                                style="width: 100%"
                              />
                              <div class="islandTitle">{{ menu.title | translate }}</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="row mt-10">
                        <div class="col-md-12">
                          <ul>
                            <li *ngFor="let menu of headermenu[0].headeritems[0].item[0].inner[0].other[0].links">
                              <a href="javascript:void(0)" (click)="islandsDetails(menu.view_node)">
                                <span>{{ menu.title | translate }}</span></a
                              >
                            </li>
                          </ul>
                          <div class="moreIslands text-center">
                            <a (click)="islands('innerIslands')" class="btn btn-outline-primary">{{
                              'More Islands' | translate
                            }}</a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-4">
                  <div class="menuMap">
                    <a href="app-googlemaps"><i class="icon-map"></i></a>
                  </div>
                </div>
                <div class="col-md-4">
                  <ul>
                    <li class="dropdown-header" *ngFor="let menu of headermenu[0].headeritems[0].item[0].outer">
                      {{ menu.subtitle | translate }}
                    </li>
                    <li>
                      <div class="row">
                        <div class="col-md-6" *ngFor="let menu of headermenu[0].headeritems[0].item[0].outer[0].data">
                          <a href="javascript:void(0)" (click)="islandGroups(menu)">
                            <div class="islandImage">
                              <img
                                class="img-responsive"
                                src="../../../assets/images/{{ menu.image }}"
                                style="width: 100%"
                              />
                              <div class="islandTitle">{{ menu.title | translate }}</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="row mt-10">
                        <div class="col-md-12">
                          <ul>
                            <li *ngFor="let menu of headermenu[0].headeritems[0].item[0].outer[0].other[0].links">
                              <a href="javascript:void(0)" (click)="islandGroups(menu)">
                                <span>{{ menu.title | translate }}</span></a
                              >
                            </li>
                          </ul>
                          <div class="moreIslands text-center">
                            <a (click)="islands('outerIslands')" class="btn btn-outline-primary">{{
                              'More Groups' | translate
                            }}</a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul> -->
          </li>
          <li class="nav-item dropdown dropdown-large" *ngFor="let menu of headermenu[0].headeritems[0].item4">
            <a href="{{ menu.url }}" (click)="categories(menu)" class="nav-link dropdown-toggle" data-toggle="dropdown"
              >{{ menu.title | translate }}
            </a>
            <!--  <div class="dropdown-menu dropdown-menu-large" style="width: 839px" [ngClass]="language">
              <div style="padding: 15px">
                <div class="row px-2 mb-2">
                  <div class="col-md-6" style="color: #000000; font-size: 16px !important; font-weight: 600">
                    {{ menu.search.title | translate }}
                  </div>
                  <div class="col-md-6 text-right">
                    <a href="{{ menu.overview.url }}" class="see-overview">
                      <span class="pi pi-search see-overview-icon"></span> {{ menu.overview.title | translate }}
                    </a>
                  </div>
                </div>
                <ul class="row">
                  <li
                    class="col-md-6 p-1"
                    (click)="categories(menu)"
                    *ngFor="let menu of headermenu[0].headeritems[0].item4[0].row"
                  >
                    <div class="island-dropdown-item" [ngStyle]="{ 'background-image': 'url(' + menu.image + ')' }">
                      <div class="island-icon-bg"></div>
                      <img src="/assets/images/icon-park_sphere.png" class="island-icon" />
                      <div class="island-title-pos">
                        <span class="island-title">{{ menu.title | translate }} </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div> -->
          </li>
        </ul>
        <ul class="navbar-nav mt-2 mt-md-0 header-nav-right">
          <li class="nav-item dropdown languageList">
            <app-language-selector inNavbar="true" menuClass="dropdown-menu dropdown-menu-right">
            </app-language-selector>
          </li>
          <li *ngIf="currentUser" class="item">
            <a title="Wishlist" href="javascript:void(0)" (click)="whishList()"><i class="icon icon-wishlist"></i></a>
          </li>
          <li class="item" *ngFor="let menu of headermenu[0].headericons[0].icons">
            <button
              class="itemSearch"
              title="{{ menu.title }}"
              href="javascript:void(0)"
              aria-label="Represent Wishlist and Search Button..."
            >
              <i class="{{ menu.iconsname }}" (click)="addpopup(menu.title)"></i>
            </button>
          </li>
          <!-- <li class="item" *ngFor="let menu of headermenu[0].headericons">
                                <a href="#" title="Search" class="searchIcon"><i class="icon icon-search-light"></i></a>
                            </li> -->
          <!-- <li class="item" *ngFor="let menu of headermenu[0].headericons">
            <a href="{{ menu.url }}" data-toggle="modal" data-target="#SignIn">{{ menu.sign }}</a>
          </li> -->
          <li>
            <a href="explore-seychelles" aria-label="Explore seychelles and filter your search to plan your trip"
              ><i class="icon-map"></i
            ></a>
          </li>
          <li>
            <button (click)="showLoginDialog()" *ngIf="!currentUser" class="nav-link dropdown-toggle">
              {{ 'Sign In' | translate }}
            </button>
          </li>
          <li class="nav-item dropdown" *ngFor="let menu of headermenu[0].headericons">
            <a
              href="javascript:void(0)"
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              *ngIf="currentUser"
            >
              {{ username }}
              <i class="icon-down-open-big"></i>
            </a>
            <div *ngIf="currentUser" class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
              <a translate class="dropdown-item" (click)="showProfileDialog()">{{ 'Profile' | translate }}</a>
              <a translate class="dropdown-item" (click)="showChangePasswordDialog()">{{
                'Change Password' | translate
              }}</a>
              <a class="dropdown-item" (click)="logout()">{{ menu.signout | translate }}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<!-- /* search model */ -->
<div class="searchModal" *ngIf="modelPopUp">
  <div class="container">
    <div class="closeModal" (click)="closepopup()"><i class="pi pi-times"></i></div>
    <div class="searchFieldModal">
      <div class="p-inputgroup">
        <p-autoComplete
          placeholder="{{ 'Search -Explore Seychelles' | translate }}"
          [suggestions]="newserachResults"
          (completeMethod)="search($event)"
          minLength="3"
          (onSelect)="goToProductDetails($event)"
          [(ngModel)]="textEnter"
          class="autoSearchBox"
        ></p-autoComplete>
        <a (click)="getSearchDetails(textEnter)" class="p-button"><i class="icon-search-light"></i></a>
      </div>
      <div>
        <!-- <p class="nearByLbl mb-1"><i class="icon-direction"></i>Near by</p> -->
      </div>
      <div class="mb-3 mt-3">
        <div *ngFor="let keyword of popularKeywords; let i = index" (click)="searchByPage(keyword)" class="btn-group">
          <button
            pButton
            type="button"
            label="{{ keyword.name }}"
            class="p-button-rounded p-button-outlined mb-2 mr-2"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
